import { AssetOrderDto, MT5ConnectionRequest, MT5AccountInfo, MT5Position, AssetDto } from './types';
import axiosInstance from './axiosConfig';

class MT5Service {
  private baseUrl = '/mt5';

  // Connection Management
  async initializeConnection(request: MT5ConnectionRequest): Promise<boolean> {
    const response = await axiosInstance.post<boolean>(`${this.baseUrl}/connect`, request);
    return response.data;
  }

  async getConnectionStatus(): Promise<boolean> {
    const response = await axiosInstance.get<boolean>(`${this.baseUrl}/connection/status`);
    return response.data;
  }

  async disconnect(): Promise<void> {
    await axiosInstance.post<void>(`${this.baseUrl}/disconnect`);
  }

  // Market Data
  async getMarketData(symbols: string[]): Promise<AssetDto[]> {
    const symbolsParam = symbols.join(',');
    const response = await axiosInstance.get<AssetDto[]>(`${this.baseUrl}/market-data?symbols=${symbolsParam}`);
    return response.data;
  }

  async getAvailableSymbols(): Promise<string[]> {
    const response = await axiosInstance.get<string[]>(`${this.baseUrl}/symbols`);
    return response.data;
  }

  // Trading Operations
  async executeOrder(orderDto: AssetOrderDto): Promise<AssetOrderDto> {
    const response = await axiosInstance.post<AssetOrderDto>(`${this.baseUrl}/orders/execute`, orderDto);
    return response.data;
  }

  async cancelOrder(orderId: string): Promise<boolean> {
    const response = await axiosInstance.delete<boolean>(`${this.baseUrl}/orders/${orderId}`);
    return response.data;
  }

  async getOrderHistory(symbol?: string, count: number = 50): Promise<AssetOrderDto[]> {
    let url = `${this.baseUrl}/orders/history?count=${count}`;
    if (symbol) {
      url += `&symbol=${symbol}`;
    }
    const response = await axiosInstance.get<AssetOrderDto[]>(url);
    return response.data;
  }

  // Account Management
  async getAccountInfo(): Promise<MT5AccountInfo> {
    const response = await axiosInstance.get<MT5AccountInfo>(`${this.baseUrl}/account/info`);
    return response.data;
  }

  async getOpenPositions(): Promise<MT5Position[]> {
    const response = await axiosInstance.get<MT5Position[]>(`${this.baseUrl}/positions`);
    return response.data;
  }

  // Helper Methods
  createMarketOrder(assetId: string, side: 'BUY' | 'SELL', quantity: number): AssetOrderDto {
    return {
      assetId,
      orderType: 'MARKET',
      side,
      quantity,
      timeInForce: 'DAY'
    };
  }

  createLimitOrder(assetId: string, side: 'BUY' | 'SELL', quantity: number, price: number): AssetOrderDto {
    return {
      assetId,
      orderType: 'LIMIT',
      side,
      quantity,
      price,
      timeInForce: 'GTC'
    };
  }
}

export default MT5Service; 